import { render, staticRenderFns } from "./GroupOrder.vue?vue&type=template&id=8de11b56&scoped=true&"
import script from "./GroupOrder.vue?vue&type=script&lang=js&"
export * from "./GroupOrder.vue?vue&type=script&lang=js&"
import style0 from "./GroupOrder.vue?vue&type=style&index=0&id=8de11b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de11b56",
  null
  
)

export default component.exports